"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(require("./TableCell"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/TableCell/index.js
// module id = 191
// module chunks = 0